import { create } from 'zustand'

export type ChatMenu = {
  groupId?: string
  visible: boolean
  show(): void
  hide(): void
  toggle(): void
  setGroupId(groupId?: string): void
}

export const useChatMenu = create<ChatMenu>(set => ({
  visible: false,

  setGroupId(groupId) {
    set({ groupId })
  },

  show() {
    set({ visible: true })
  },

  hide() {
    set({ visible: false })
  },

  toggle() {
    set(s => ({
      visible: !s.visible,
    }))
  },
}))
